import React from 'react';

/**
 * Pagination component with range display and page indicator.
 *
 * Props:
 *  - hasMore, hasPrev, onNext, onPrev, loading
 *  - total: total record count
 *  - page: current page number (1-based)
 *  - pageSize: items per page (default 20)
 *  - itemCount: number of items on current page
 */
export default function Pagination({
  hasMore,
  onNext,
  onPrev,
  hasPrev,
  loading,
  total,
  page = 1,
  pageSize = 20,
  itemCount,
}) {
  const fmt = (n) => new Intl.NumberFormat().format(n);

  const first = total != null && total > 0 ? (page - 1) * pageSize + 1 : 0;
  const last =
    total != null && total > 0
      ? Math.min(first + (itemCount != null ? itemCount : pageSize) - 1, total)
      : 0;
  const pageCount = total != null && total > 0 ? Math.ceil(total / pageSize) : 0;

  return (
    <div className="d-flex justify-content-between align-items-center py-2">
      <div style={{ fontSize: '0.8125rem', color: '#525b75' }}>
        {total != null && total > 0 ? (
          <span>
            <strong>{fmt(first)}</strong>〜<strong>{fmt(last)}</strong> 件 / 全{' '}
            <strong>{fmt(total)}</strong> 件
          </span>
        ) : total === 0 ? (
          <span>0 件</span>
        ) : null}
      </div>
      <div className="d-flex align-items-center gap-2">
        {pageCount > 1 && (
          <span style={{ fontSize: '0.8125rem', color: '#8a94ad' }}>
            {page} / {fmt(pageCount)} ページ
          </span>
        )}
        {onPrev && (
          <button
            type="button"
            className="btn btn-phoenix-secondary btn-sm"
            onClick={onPrev}
            disabled={loading || !hasPrev}
          >
            &laquo; 前へ
          </button>
        )}
        <button
          type="button"
          className="btn btn-phoenix-secondary btn-sm"
          onClick={onNext}
          disabled={loading || !hasMore}
        >
          次へ &raquo;
        </button>
      </div>
    </div>
  );
}
